import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Button from "../../common/Button";
import { downloadTestFeedback, testFeedbackUrl } from "../../api/profileApi";
import {
  isDownloadAttrSupported,
  forceDownload,
} from "../../containers/ResourceFolders/util";

const downloadFeedback = async (testName) => {
  if (isDownloadAttrSupported()) {
    return downloadTestFeedback(testName).then((response) =>
      forceDownload(response, "Big_5_Personality_Test_Feedback_Fields.pdf")
    );
  }
  return window.open(testFeedbackUrl(testName), "_blank");
};
const Big5PersonalityTestIndex = ({ appData }) => {
  return (
    <article>
      <div className="styles__resource__wrapper___EooDq">
        <h4 className="styles__resource__title___3swKq">
          Big Five Personality Test
        </h4>
        <p className="styles__resource__description___2yhR0">
          <b>
            The big five personality traits are the best accepted and most
            commonly used model of personality in academic psychology. The big
            five come from the statistical study of responses to personality
            items. Using a technique called factor analysis, researchers can
            look at the responses of people to hundreds of personality items and
            ask the question, &quot;What is the best way to summarize an
            individual?&quot;
            <br />
            <br />
            This has been done with many samples from all over the world and the
            general result is that, while there seem to be unlimited personality
            variables, five stand out from the pack in terms of explaining
            answers to questions about people&apos;s personality. These are
            extraversion, neuroticism, agreeableness, conscientiousness and
            openness to experience.
            <br />
            <br />
            The big five are not associated with any particular test, a variety
            of measures have been developed to measure them. This test uses the
            Big-Five Factor Markers from the International Personality Item
            Pool, developed by Goldberg in 1992.
            <br />
            <br />
            The test consists of fifty items that you must rate on how true they
            are about you on a five point scale. The test should take 3-8
            minutes to complete.
            <br />
            <br />
            This test is provided for educational use only. It should not be
            used as psychological advice of any kind and comes without any
            guarantee of accuracy or fitness for any particular purpose.
            <br />
            <br />
            In taking this test, you consent to HRGO storing and processing the
            information you provide in order to provide you with the test
            result. The information you provide may also be used to find the
            most suitable job for you, to share with clients, train our data
            models, improve and iterate these tests, and provide you with the
            most relevant advertising and courses. Where the data does not
            require attribution; we will anonymise your information for
            processing.
            <br />
            <br />
            {appData.big5PersonalityTestHandling
              ? " Please click Download to get your feedback."
              : " Please click Launch to complete this test."}
          </b>
        </p>
        <div className="d-flex flex-column">
          {appData.big5PersonalityTestHandling ? (
            <Button
              onClick={() => {
                downloadFeedback("big5Personality");
              }}
              id="btnBasicInfoEditSubmit"
              classes="btn btn-primary ml-auto"
            >
              Download
            </Button>
          ) : (
            <Link
              to="/profile/MyTests/Big5Personality"
              className="btn btn-primary ml-auto"
            >
              Launch
            </Link>
          )}
        </div>
      </div>
    </article>
  );
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, null);
export default withRedux(Big5PersonalityTestIndex);
